import { IsNotEmpty } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { BoardExcelFloorCreatableInterface } from '../interfaces/board-excel-floor-creatable.interface';

export class BoardExcelFloorCreateDto
  implements BoardExcelFloorCreatableInterface
{
  @ApiProperty({
    title: 'Board Excel',
    type: 'string',
    description: 'Data from excel',
  })
  @IsNotEmpty()
  data!: string;
}
